import ShamlForm from "./pages/shaml-form/store";

export default {
  namespaced: true,
  modules: {
    ShamlForm,
  },
};
